import React from "react";
import { useSelector } from "react-redux";
import numbro from "numbro";
import Chart from "../../../../components/charts/pieChart/pieChart";

const tooltipFormatter = ({ index, labels, chartValues, currency }) => {
  return [
    `${labels[index]} (#): ${numbro(chartValues[index][1]).format("0,0")}`,
    `${labels[index]} (${currency}): ${currency}${numbro(chartValues[index][2]).format("0,0")}`
  ];
};

const PieChart = ({ chartData }) => {
  const currency = useSelector((state) => state.commonReducer.commonProps.currencySymbol);

  return (
    <div className="pie-chart">
      <Chart
        height={350}
        width={450}
        data={chartData}
        showLegend
        legendPosition="right"
        legendTooltipPosition="left"
        currency={currency}
        legendLabelMaxLength={9}
        showPercent
        hideTooltipTitle
        isLegendTooltip
        tooltipFormatter={tooltipFormatter}
      />
    </div>
  );
};

export default PieChart;
